import { createFileRoute } from "@tanstack/react-router";

import { MoneyHomePage } from "@/features/money/pages";

/** The money section opens on what waits for staff, and what the wallets hold. */
export const Route = createFileRoute("/_app/money/")({
  component: MoneyHomePage,
});
